import "./SearchStatus.css";
import { Spinner } from "../Spinner/Spinner";

export const SearchStatus = ({isLoading}) => {
    return (
        <div id='searchStatus'>
            <Spinner isLoading={isLoading} />
        </div>
    )
}